module.exports = __webpack_public_path__ + "static/gallery2-0a5e01dc28549b79295bc248b62f03ba.jpg";